'use strict';

const $ = require('jquery');

class MobileMenu {

    constructor() {

        this.desktopMenu();
        this.mobileMenu();

    }

    desktopMenu() {

        let $menuItem = $('.menu-header [data-sub-menu]');

        $menuItem.on('mouseover', (event) => {

            this.closeDesktopMenu();

            let id = $(event.target).data('sub-menu');

            App.Globals.$body.addClass('sub-menu-open');
            $(`#sub-menu-${id}`).addClass('active');
        });

        $('.sub-menu').on('mouseleave', () => {

            this.closeDesktopMenu();
        });

    }

    closeDesktopMenu() {

        App.Globals.$body.removeClass('sub-menu-open');
        $('.sub-menu').removeClass('active');

    }

    mobileMenu() {

        let mobileMenu = document.querySelectorAll('.menu-mobile');

        if (mobileMenu.length > 0) {

            require('./../../../../build/node_modules/@components/mmenu/dist/mmenu.js');
            require('./../../../../build/node_modules/@components/mmenu/dist/mmenu.polyfills.js');

            new Mmenu('.menu-mobile', {
                    offCanvas: false,
                }
            );

        }

    }

}

module.exports = MobileMenu;
